import { render, staticRenderFns } from "./Form6StyleOfProceeding.vue?vue&type=template&id=d1a51988&scoped=true"
import script from "./Form6StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form6StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form6StyleOfProceeding.vue?vue&type=style&index=0&id=d1a51988&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a51988",
  null
  
)

export default component.exports